import React from 'react';
import './AboutSection.css';
import { FaUniversity, FaHandHoldingUsd, FaRocket, FaUsers, FaExchangeAlt, FaCreditCard, FaLink, FaMobileAlt, FaCoins } from 'react-icons/fa';
import bankImage from '../images/bank.jpg';
import loanImage from '../images/lenders.jpg';
import analyticsImage from '../images/analytics.jpg';
import securityImage from '../images/creditunion.jpg';
import mfiHero from '../images/mfi-hero.jpg';
import chitHero from '../images/assetandgold.png';
import coopHero from '../images/sas.jpg';
import inventoryImg from '../images/paylater.jpg';
import complianceImg from '../images/embeded.png';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function AboutSection() {

const location = useLocation();

  useEffect(() => {
    if (location.hash) {

      const element = document.querySelector(location.hash);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        }, 100);
      }

    }
  }, [location]);

    const whoWeServe = [
        { icon: <FaUniversity />, title: "Banks", desc: "Transform traditional banking with digital-first, scalable capabilities.", size: "large", img: bankImage },
        { icon: <FaHandHoldingUsd />, title: "Lenders", desc: "From NBFCs to microfinance, scale lending with precision.", size: "small", img: loanImage },
        { icon: <FaRocket />, title: "Fintechs", desc: "Launch financial products fast with our ready-to-use infrastructure.", size: "small", img: analyticsImage },
        { icon: <FaUsers />, title: "Credit Unions", desc: "Member-focused digital transformation for cooperative banking.", size: "medium", img: securityImage }
    ];

    const useCases = [
        { icon: <FaExchangeAlt />, tag: "BaaS", title: "Banking-as-a-Service", desc: "White-label solutions to embed financial services into any platform.", img: coopHero },
        { icon: <FaMobileAlt />, tag: "Digital", title: "Digital Lending", desc: "Complete loan lifecycle from origination to automated recovery.", img: mfiHero },
        { icon: <FaCoins />, tag: "Gold", title: "Gold & Asset Finance", desc: "Secured lending solutions with intelligent risk management.", img: chitHero },
        { icon: <FaLink />, tag: "Embedded", title: "Embedded Finance", desc: "Seamlessly integrate lending and payments into non-financial apps.", img: complianceImg },
        { icon: <FaCreditCard />, tag: "BNPL", title: "Buy Now Pay Later", desc: "End-to-end management from merchant onboarding to recovery.", img: inventoryImg }
    ];

    return (
        <section className="about-section-maximized">
            <div className="maximized-bg-overlay"></div>

            <div className="about-container-modern">
                <div className="about-header-modern animate-fadeInUp">
                    <span className="modern-badge">Modular Banking Ecosystem</span>
                    <h2 className="about-title-modern">Features you need,<br /> activated when you want them.</h2>
                    <p className="about-subtitle-modern">Innovate faster with pre-configured, compliance-ready banking modules designed for the modern era.</p>
                </div>

                <div className="segments-mosaic-layout" id="whoweserve">

                    <div className="mosaic-grid-premium">
                        {whoWeServe.map((item, idx) => (
                            <div key={idx} className={`mosaic-card-premium card-${idx}`}>
                                <div className="mosaic-card-inner">
                                    <div className="mosaic-image-bg" style={{ backgroundImage: `url(${item.img})` }}></div>
                                    <div className="mosaic-overlay"></div>
                                    <div className="mosaic-content-premium">
                                        <div className="mosaic-icon-premium">{item.icon}</div>
                                        <div className="mosaic-text-premium">
                                            <h4>{item.title}</h4>
                                            <p>{item.desc}</p>
                                        </div>
                                    </div>
                                    <div className="mosaic-hover-indicator"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                    <div className="section-heading-modern">
                        <h3 className="section-label-modern">
                            IGNOSI Cloud Banking Platform
                        </h3>

                        <h2 className="section-title-modern">
                            Modern Banking Infrastructure for the Digital Age
                        </h2>
                    </div>
                <div className="usecase-scroll-layout" id="usecases">
                    <h3 className="section-label-modern">Industry Use Cases</h3>
                    <div className="flow-wrapper-maximized">
                        <div className="flow-container-maximized">
                            {useCases.map((item, idx) => (
                                <div key={idx} className="flow-node-maximized">
                                    <div className="node-image-wrap">
                                        <img src={item.img} alt={item.title} />
                                        <div className="node-icon-overlay">{item.icon}</div>
                                    </div>
                                    <div className="node-visual">
                                        <div className="node-icon-wrapper-max">
                                            {item.icon}
                                            <span className="node-tag-max">{item.tag}</span>
                                        </div>
                                        {idx < useCases.length - 1 && <div className="node-line-max"></div>}
                                    </div>
                                    <div className="node-content-max">
                                        <h4>{item.title}</h4>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutSection;
